import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { colours } from '@qflow/theme'

import * as ButtonBase from './ButtonBase'

export const Clickable = forwardRef(
  ({ children, onClick, innerCSS, ...props }, ref) => {
    return (
      <StyledButton onClick={onClick} {...props} ref={ref}>
        <Children css={innerCSS}>{children}</Children>
      </StyledButton>
    )
  }
)

Clickable.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  innerCSS: PropTypes.any
}

export const ClickableCSS = css`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: () => 'transparent',
    getBgDisabled: () => 'transparent'
  })}
  ${ButtonBase.getShapeCSS()}

  display: inline-block;
  flex: 0 0 auto;

  min-width: 2rem;
  width: auto;
  min-height: 2rem;
  max-height: none;

  :hover {
    background-color: ${colours.CONTROL_PANEL_GREY};
    color: ${colours.CORE_NAVY};
  }

  :active {
    background-color: ${colours.CONTROL_PANEL_GREY};
    color: ${colours.CORE_NAVY};
  }

  ${({ css }) => css}
`

const StyledButton = styled.button`
  ${ClickableCSS}
`

const Children = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ css }) => css}
`
